const KEY = 'access-audit-logs-v1';

const seed = [
  { id: 'log-001', ts: '2025-09-16T09:15:00Z', user: 'alice@krotrust.org', action: 'role.update', target: 'role-manager', status: 'success', ip: '10.0.0.5' },
  { id: 'log-002', ts: '2025-09-16T09:20:30Z', user: 'bob@krotrust.org', action: 'login', target: '-', status: 'success', ip: '10.0.0.7' },
  { id: 'log-003', ts: '2025-09-16T10:02:10Z', user: 'alice@krotrust.org', action: 'role.create', target: 'role-analyst', status: 'success', ip: '10.0.0.5' },
  { id: 'log-004', ts: '2025-09-16T10:15:44Z', user: 'carol@krotrust.org', action: 'permission.toggle', target: 'role-analyst:view_reports', status: 'failure', ip: '10.0.0.9' },
];

function load(){ try{ const raw = localStorage.getItem(KEY); return raw ? JSON.parse(raw) : seed; }catch{ return seed; } }

let logs = load();
const subs = new Set();

function save(){ try{ localStorage.setItem(KEY, JSON.stringify(logs)); }catch{} }
function publish(){ save(); subs.forEach(cb=> { try{ cb(logs); }catch{} }); }

export function subscribe(cb){ subs.add(cb); cb(logs); return ()=> subs.delete(cb); }
export function add(entry){ logs.unshift({ id: entry.id || `log-${Math.random().toString(36).slice(2,8)}`, ts: new Date().toISOString(), status: 'success', ...entry }); publish(); }
export function clear(){ logs = []; publish(); }

export function search({ q='', user='all', action='all', status='all', from=null, to=null }={}){
  const query = q.trim().toLowerCase();
  const fromDt = from ? new Date(from) : null;
  const toDt = to ? new Date(to) : null;
  return logs.filter(l=>{
    if(user!=='all' && l.user!==user) return false;
    if(status!=='all' && l.status!==status) return false;
    if(action!=='all' && l.action!==action) return false;
    const ts = new Date(l.ts);
    if(fromDt && ts < fromDt) return false;
    if(toDt && ts > toDt) return false;
    if(!query) return true;
    return [l.user,l.action,l.target,l.ip,l.id].some(v=> String(v).toLowerCase().includes(query));
  });
}

export function listDistinct(){
  const users = Array.from(new Set(logs.map(l=> l.user)));
  const actions = Array.from(new Set(logs.map(l=> l.action)));
  const statuses = Array.from(new Set(logs.map(l=> l.status)));
  return { users, actions, statuses };
}

export function exportJSON(){ return logs; }
export function importJSON(arr){ if(!Array.isArray(arr)) return; logs = arr; publish(); }
